import { render } from "./MahalaxmiAshish.vue?vue&type=template&id=3d5e201c"
import script from "./MahalaxmiAshish.vue?vue&type=script&lang=js"
export * from "./MahalaxmiAshish.vue?vue&type=script&lang=js"

import "./MahalaxmiAshish.vue?vue&type=style&index=0&id=3d5e201c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__